import { render, staticRenderFns } from "./OrderChargeOff.vue?vue&type=template&id=97bbe4e2&"
import script from "./OrderChargeOff.vue?vue&type=script&lang=js&"
export * from "./OrderChargeOff.vue?vue&type=script&lang=js&"
import style0 from "./OrderChargeOff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports